import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { FlaskConical } from "lucide-react";
import { apiFetch } from "@/lib/api";
import { cn } from "@/lib/cn";
import { isTrainingEnvironment, type HealthEnvironment } from "@/lib/environment";

const ORIGINAL_TITLE = typeof document === "undefined" ? "" : document.title;

/**
 * Dải "Môi trường đào tạo" — anh Toàn chốt 07/10/2026: một bản riêng với dữ
 * liệu mẫu để nhân viên Hisense thử mọi tính năng mà không đụng tới production.
 *
 * Không đóng được và hiện cả ở trang đăng nhập: người dùng phải biết mình đang
 * ở đâu TRƯỚC khi gõ mật khẩu, và không bao giờ nhập nhầm chứng từ thật vào
 * bản thử. Tên tab cũng mang tiền tố để hai cửa sổ cạnh nhau không lẫn.
 * Production không hiện gì (máy chủ báo `production`).
 */
export function EnvironmentBanner({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { data } = useQuery({
    queryKey: ["health-environment"],
    queryFn: () => apiFetch<HealthEnvironment>("/health"),
    staleTime: Infinity,
    retry: 1,
  });
  const training = isTrainingEnvironment(data);
  const label = t("trainingEnv.label");

  useEffect(() => {
    if (!training) return;
    document.title = `${label} · ${ORIGINAL_TITLE}`;
    return () => {
      document.title = ORIGINAL_TITLE;
    };
  }, [training, label]);

  if (!training) return null;
  return (
    <div
      role="note"
      className={cn(
        "flex shrink-0 items-center justify-center gap-2 border-b-2 border-warn bg-warn-tint px-4 py-1.5 text-center text-xs text-ink",
        className,
      )}
    >
      <FlaskConical className="size-4 shrink-0 text-warn" aria-hidden="true" />
      <span>
        <strong className="font-semibold">{label}</strong>
        <span className="text-ink-soft"> · {t("trainingEnv.detail")}</span>
      </span>
    </div>
  );
}
